import { defineMessages } from 'react-intl'

export default defineMessages({
  action1: {
    id: 'components.BankCard.action1',
    defaultMessage: 'Transaction History',
    description: 'Transaction History',
  },
  actionDeleteBankCard: {
    id: 'components.BankCard.actionDeleteBankCard',
    defaultMessage: 'Delete the bank card',
    description: 'Delete the bank card',
  },
  actionDeleteAccount: {
    id: 'components.BankCard.actionDeleteAccount',
    defaultMessage: 'Delete the bank account',
    description: 'Delete the bank account',
  },
  action3: {
    id: 'components.BankCard.action3',
    defaultMessage: 'Cancel',
    description: 'Cancel',
  },
  deleteCardConfirmInfo: {
    id: 'components.BankCard.deleteCardConfirmInfo',
    defaultMessage: 'Confirm to delete this bank card!',
    description: 'Confirm to delete this bank card!',
  },
  deleteAccountConfirmInfo: {
    id: 'components.BankCard.deleteAccountConfirmInfo',
    defaultMessage: 'Confirm to delete this bank account!',
    description: 'Confirm to delete this bank account!',
  },
  delete: {
    id: 'components.BankCard.delete',
    defaultMessage: 'DELETE',
    description: 'DELETE',
  },
  notNow: {
    id: 'components.BankCard.notNow',
    defaultMessage: 'NOT NOW',
    description: 'NOT NOW',
  },
  validDateDue: {
    id: 'components.BankCard.validDateDue',
    defaultMessage: 'ValidDate due',
    description: 'ValidDate due',
  },
  validDateOverdue: {
    id: 'components.BankCard.validDateOverdue',
    defaultMessage: 'ValidDate overdue',
    description: 'ValidDate overdue',
  },
  ibanNumber: {
    id: 'components.BankCard.ibanNumber',
    defaultMessage: 'IBAN NUMBER',
    description: 'IBAN NUMBER',
  },
  cardNumber: {
    id: 'components.BankCard.cardNumber',
    defaultMessage: 'CARD NUMBER',
    description: 'CARD NUMBER',
  },
})
